import gql from 'graphql-tag';

export const GET_INVENTORY_FULL_LIST = gql`
  query DealBuilderInventoryFullList($input: InternalInventoryFullList!) {
    result: internalInventoryFullList(input: $input) {
      success
      error
      list {
        id
        equipment {
          id
          assets {
            id
            source
          }
          price {
            retailPrice
            wholesaleCost
            totalWholesaleCost
          }
          details {
            make
            vin
            year
            model
            name
            class
            mileage
            stockId
            condition
            description
          }
        }
      }
    }
  }
`;
